import { format, isWithinInterval, startOfDay, endOfDay } from 'date-fns';
import { ApiV1_Promotion, ApiV1_PromotionConditions, DayOfWeek, EvaluationContext } from '../promotion.types';

export function evaluateConditions(promotion: ApiV1_Promotion, context: EvaluationContext): boolean {
  const { conditions } = promotion;

  if (!conditions) {
    return true;
  }

  if (!evaluateDaysOfWeek(conditions.daysOfWeek, context.currentDate)) {
    return false;
  }

  if (!isPromotionWithinPeriod(conditions.period, context.currentDate)) {
    return false;
  }

  return true;
}

function evaluateDaysOfWeek(daysOfWeek: DayOfWeek[] | undefined, currentDate: Date): boolean {
  if (!daysOfWeek || daysOfWeek.length === 0) {
    return true;
  }

  const dayOfWeek = Number(format(currentDate, 'i')) as DayOfWeek;
  return daysOfWeek.includes('ALL') || daysOfWeek.includes(dayOfWeek);
}

export function isPromotionWithinPeriod(
  period: ApiV1_PromotionConditions['period'],
  currentDate: Date,
): boolean {
  if (!period) {
    return true;
  }

  const { startDate, endDate } = period;

  if (!startDate && !endDate) {
    return true;
  }

  const start = startDate ? startOfDay(new Date(startDate)) : new Date(0);
  const end = endDate ? endOfDay(new Date(endDate)) : new Date(8640000000000000);

  return isWithinInterval(currentDate, { start, end });
}
